import { render, staticRenderFns } from "./SkinButton.vue?vue&type=template&id=33acb059&"
import script from "./SkinButton.vue?vue&type=script&lang=ts&"
export * from "./SkinButton.vue?vue&type=script&lang=ts&"
import style0 from "./SkinButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports